import { NotificationHeaderProps } from 'components/Notifications/types';
import React from 'react';
import {
  StyledBadge,
  StyledNotificationHeader,
} from 'components/Notifications/styles';
import { Grid } from '@material-ui/core';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import { LargeSectionHeader, Captions } from 'components/Typography';

const NotificationHeader = ({
  title,
  close,
  total,
}: NotificationHeaderProps) => {
  return (
    <StyledNotificationHeader
      container
      alignItems="center"
      justify="space-between"
    >
      <Grid item>
        <Grid container alignItems="center">
          <LargeSectionHeader style={{ margin: 0 }}>{title}</LargeSectionHeader>
          <StyledBadge size={20}>
            <Captions color="#FFFFFF">{total}</Captions>
          </StyledBadge>
        </Grid>
      </Grid>
      <Grid item>
        <ClearOutlinedIcon onClick={close} />
      </Grid>
    </StyledNotificationHeader>
  );
};

export default NotificationHeader;
